<template>
  <div role="group" class="b-form-group form-group">
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('SUBJECT')">
          <inputvalidation :formerror="formError" name="subject">
            <b-form-input type="text" v-model="formData.subject"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('STARTTIME')">
          <inputvalidation :formerror="formError" name="startTime">
             <datetimepicker v-model="formData.startTime" format="DD.MM.YYYY HH:mm:ss" :first-day-of-week="1" :lang="lang" type="datetime"></datetimepicker>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('ENDTIME')">
          <inputvalidation :formerror="formError" name="endTime">
            <datetimepicker v-model="formData.endTime" format="DD.MM.YYYY HH:mm:ss" :first-day-of-week="1" :lang="lang" type="datetime"></datetimepicker>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('CHILDREN')">
          <inputvalidation :formerror="formError" name="childId">
              <lb-vue-select v-model="formData.childId"
                              :list="children.root"
                              :totalCount="children.totalCount"
                              :pagination="pagination"
                              display-field="fullname"
                              value-field="childId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('CHILDREN')"
                              v-on:reload="getData">
                </lb-vue-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg" v-if="globals.companyId == 2">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('ROOM')">
          <inputvalidation :formerror="formError" name="roomId">
              <lb-vue-select v-model="formData.roomId"
                              :list="rooms.root"
                              :totalCount="rooms.totalCount"
                              :pagination="roomPagination"
                              display-field="name"
                              value-field="roomId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('ROOMS')"
                              v-on:reload="getRoom">
                </lb-vue-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('USERS')">
          <inputvalidation :formerror="formError" name="userId">
              <lb-vue-select v-model= "formData.userId"
                              :list= "users.root"
                              :totalCount= "users.totalCount"
                              display-field= "username"
                              value-field= "userId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('USERS')">
                </lb-vue-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import ChildrenApi from '@/api/child/Child';
import RoomApi from '@/api/room/Room';

export default {
    name: 'EventsForm',
    props: ['formData', 'formError', 'users'],
    data()
    {
        const me = this;
        return {
            lang: {

                days: [me.$t('SUN'), me.$t('MON'), me.$t('TUE'),
                    me.$t('WED'), me.$t('THU'), me.$t('FRI'), me.$t('SAT')],
                months: [me.$t('JAN'), me.$t('FEB'), me.$t('MAR'), me.$t('APR'),
                    me.$t('MAY'), me.$t('JUN'), me.$t('JUL'), me.$t('AUG'), me.$t('SEP'),
                    me.$t('OCT'), me.$t('NOV'), me.$t('DEC')],
                pickers: [me.$t('NEXT7DAYS'), me.$t('NEXT30DAYS'), me.$t('PREVIOUS7DAYS'), me.$t('PREVIOUS30DAYS')],
                placeholder: {
                    date: me.$t('SELECTDATE'),
                    dateRange: me.$t('SELECTDATERANGE'),
                },
            },
            children: {},
            rooms: {},
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
            roomPagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getRoom();
    },
    methods:
  {
      async getData()
      {
          const me = this;

          try
          {
              const data = await ChildrenApi.selectRow(me.getParamsChildren);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.children = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getRoom()
      {
          const me = this;

          try
          {
              const data = await RoomApi.selectRow(me.getParamsRoom);
              if (data.error && data.error === true)
              {
                  throw (data);
              }

              data.root.unshift({ roomId: 0, name: me.$t('DEFAULTROOM') });
              me.rooms = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      translateDateTimePicker(val)
      {
          const me = this;
          return me.$t(val.toUpperCase());
      },
  },
    watch:
  {
      'formData.childId'(val)
      {
          const me = this;
          me.formData.subject = '';
          for (const item of me.children.root)
          {
              if (val != null && val.search(item.childId) !== -1)
              {
                  if (me.formData.subject === '')
                  {
                      me.formData.subject += item.fullname;
                  }
                  else
                  {
                      me.formData.subject += `, ${item.fullname}`;
                  }
              }
          }
          return val;
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParamsChildren()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsRoom()
      {
          const me = this;
          const data = {
              ...me.roomPagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },

};
</script>
